import { render } from "./Acquisitor.vue?vue&type=template&id=eac7a5ba&scoped=true"
import script from "./Acquisitor.vue?vue&type=script&lang=js"
export * from "./Acquisitor.vue?vue&type=script&lang=js"

import "./Acquisitor.vue?vue&type=style&index=0&id=eac7a5ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac7a5ba"]])

export default __exports__